// Copyright (c) Microsoft Corporation. All rights reserved.

import SampleApp from "./pages/SampleApp";
import SampleAppPremeeting from "./pages/SampleAppPreMeeting";
import WegoConfiguration from "./wego/WegoConfiguration";

export const WegoConfig: WegoConfiguration = {
  aadAppId: process.env.REACT_APP_AAD!,
  clientUrl: process.env.REACT_APP_CLIENT_URL!,
  debugBrowserMeetingId: "MCMxOTptZWV0aW5nX09UQXdNMlEyWVRZdE1qUmxaQzAwT0dZNUxXSmxOelV0Wmpoa1ltRmxZalJrTkRGbUB0aHJlYWQudjIjMA==",
  debugBrowserTenantId: "72f988bf-86f1-41af-91ab-2d7cd011db47"
}

export default Object.freeze({
  SampleApp: {
    appName: "sampleapp",
    appMeetingType: SampleApp,
    appPreMeetingType: SampleAppPremeeting,
    id: "95f95cc8-e487-4d38-a270-293dd42b2032"
  }
});